import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Navig8Form from '../../../../sonar/navig8/components/navig8-from/Navig8Form';
import Navig8Messages from '../../../../sonar/navig8/components/navig8-messages/Navig8Messages';
import {
  getConsumerSonarNavig8,
  replyConsumerSonarNavig8,
} from '../../../../redux/consumer/sonar/consumerSonarActions';

import scss from './Navig8Consumer.module.scss';

function Navig8Consumer() {
  const dispatch = useDispatch();

  const dateRanges = useSelector((state) => state.sonarDashboard.dateRanges);
  const thread = useSelector((state) => state.sonarDashboard.navig8.thread);
  const navig8AbortController = useSelector((state) => state.sonarDashboard.navig8AbortController);

  const handleReply = ({ reply }) => {
    dispatch(replyConsumerSonarNavig8({ reply }));
  };

  useEffect(() => {
    if (!thread && !navig8AbortController) {
      dispatch(getConsumerSonarNavig8());
    }
  }, [dispatch, thread, dateRanges]);

  return (
    <div className={scss.wrapper}>
      <Navig8Form onReply={handleReply} />

      <Navig8Messages />
    </div>
  );
}

export default Navig8Consumer;
